import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { login } from "../../../actions/auth";
import { setAlert } from "../../../actions/alert";

import Alert from "../IME/Alert";

const UserLogin = ({ login, auth: { user }, isAuthenticated, setAlert }) => {
  const [profileDropDown, setprofileDropDown] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const { email, password } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      setAlert("Please enter a valid email");
    }
    if (password === "") {
      setAlert("Please enter a password");
    }
    login(email, password);
  };

  return (
    <Fragment>
      <div className="login-container">
        <form
          className="main"
          action="/:channelid"
          method="POST"
          onSubmit={(e) => onSubmit(e)}
        >
          <div className="action-items-index green">
            <Link to="/register">
              <div className="action-button-index green">
                <i className="fas fa-user action-icon-index fa-lg green"></i>
              </div>
            </Link>
            <p className="action-text-index green">Register</p>
          </div>
          <div className="action-items-index green">
            <div
              className="action-button-index green"
              onClick={() => {
                if (!profileDropDown) {
                  setprofileDropDown(true);
                } else {
                  setprofileDropDown(false);
                }
              }}
            >
              <i className="fas fa-user action-icon-index fa-lg green"></i>
            </div>
            <p className="action-text-index">Login</p>
          </div>
          {profileDropDown && (
            <div className="profile-drop-down-alt">
              <div className="profile-drop-container-nav">
                <div className="label-input">
                  <label htmlFor="email" className="labels green">
                    *Email:
                  </label>
                  {email === "" && <Alert />}
                  <input
                    name="email"
                    className="input-style-nav"
                    type="email"
                    value={email}
                    placeholder="Enter Email Address"
                    onChange={(e) => onChange(e)}
                    tabIndex="2"
                  />
                </div>
                <div className="label-input">
                  <label htmlFor="password" className="labels green">
                    *Password:
                  </label>
                  {password === "" && <Alert />}
                  <input
                    name="password"
                    className="input-style-nav"
                    type="password"
                    min={7}
                    maxLength={20}
                    value={password}
                    placeholder="Enter Password"
                    onChange={(e) => onChange(e)}
                    tabIndex="2"
                  />
                  {email !== "" && password !== "" && (
                    <div className="login-button-container-alt">
                      <button
                        className="login-button-alt background-green"
                        type="submit"
                      >
                        Login
                      </button>
                    </div>
                  )}
                  <Link to="/forgotpassword">
                    <p className="forgot green" tabIndex="4">
                      Forgot Password?
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </form>
      </div>
    </Fragment>
  );
};

UserLogin.propTypes = {
  login: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { login, setAlert })(UserLogin);
